var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobalReach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 7.225C10.0625 6.375 9.37499 5.6875 8.52499 5.6875C7.67499 5.6875 6.98749 6.375 6.98749 7.225V29.175H10.075V7.225H10.0625Z",
    fill: "#002C3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 19.3001C16.85 18.1126 19.15 22.8876 23.825 20.1876V7.22506C19 10.0126 16.25 5.65006 12.1125 6.43756C12.175 6.70006 12.2 6.96256 12.2 7.22506V19.3001H12.1875Z",
    fill: "#002C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0875 7.225C30.0875 6.375 29.4 5.6875 28.55 5.6875C27.7 5.6875 27.0125 6.375 27.0125 7.225V29.175H30.1V7.225H30.0875Z",
    fill: "#47ADB2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2125 19.3001C36.875 18.1126 39.175 22.8876 43.85 20.1876V7.22506C39.025 10.0126 36.275 5.65006 32.1375 6.43756C32.2 6.70006 32.225 6.96256 32.225 7.22506V19.3001H32.2125Z",
    fill: "#47ADB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1125 7.225C50.1125 6.375 49.425 5.6875 48.575 5.6875C47.725 5.6875 47.0375 6.375 47.0375 7.225V29.175H50.125V7.225H50.1125Z",
    fill: "#002C3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1625 6.43757C52.225 6.70007 52.25 6.96257 52.25 7.22507V19.2876C56.9125 18.1001 59.2125 22.8751 63.8875 20.1751V7.21257C59.05 10.0126 56.3 5.65007 52.1625 6.43757Z",
    fill: "#002C3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1625 45.8251C19.75 44.8751 23.6125 44.3626 27.4875 44.2751V31.3H12.3375C12.4875 36.525 13.8625 41.4626 16.1625 45.8251Z",
    fill: "#002C3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7625 31.3H29.6125V44.2626C33.4875 44.3376 37.35 44.8625 40.9375 45.8125C43.25 41.4625 44.6125 36.525 44.7625 31.3Z",
    fill: "#002C3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2125 31.3H0.125C0.375 38.2375 3.1125 44.5376 7.475 49.3376C9.475 48.1626 11.7 47.1875 14.0875 46.425C11.7375 41.8625 10.3625 36.7375 10.2125 31.3Z",
    fill: "#002C3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1875 58.3125C38.9125 57.375 44.0625 54.7249 48.0875 50.9124C46.225 49.8624 44.1625 49 41.975 48.325C39.6875 52.175 36.7 55.5625 33.1875 58.3125Z",
    fill: "#002C3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.025 46.425C45.4 47.1875 47.6375 48.1626 49.6375 49.3376C54 44.5376 56.7375 38.2375 56.9875 31.3H46.9C46.7375 36.7375 45.3625 41.8625 43.025 46.425Z",
    fill: "#002C3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.85 47.7251C36.6 46.9126 33.1125 46.4751 29.6125 46.4001V58.2626C33.7625 55.5501 37.25 51.9501 39.85 47.7251Z",
    fill: "#002C3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 48.325C12.925 49.0125 10.8625 49.8749 9.01251 50.9124C13.05 54.7249 18.1875 57.375 23.9125 58.3125C20.4 55.5625 17.4125 52.175 15.125 48.325Z",
    fill: "#002C3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4875 58.2626V46.4001C23.975 46.4751 20.5 46.9126 17.25 47.7251C19.85 51.9501 23.3375 55.5501 27.4875 58.2626Z",
    fill: "#002C3E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalReach);
export default __webpack_public_path__ + "static/media/GlobalReach.3b4b89d9f10f8baa319a7edcd30bc32d.svg";
export { ForwardRef as ReactComponent };